// Tema de status da nota fiscal — fonte única de cores, usada pela lista e pelo detalhe.
export type StatusColor = { bg: string; text: string; dot: string };

export const STATUS_COLORS: Record<string, StatusColor> = {
  Autorizada:  { bg: '#E6F9F1', text: '#00845E', dot: '#00B37E' },
  Emitida:     { bg: '#E6F9F1', text: '#00845E', dot: '#00B37E' },
  Emitindo:    { bg: '#EFF6FF', text: '#1D4ED8', dot: '#3B82F6' },
  Pendente:    { bg: '#FFF7E6', text: '#996B00', dot: '#FFB800' },
  Rejeitada:   { bg: '#FEECEC', text: '#9B111E', dot: '#F75A68' },
  Negada:      { bg: '#FEECEC', text: '#9B111E', dot: '#F75A68' },
  Cancelada:   { bg: '#F2EEFF', text: '#005D99', dot: '#996DFF' },
  Inutilizada: { bg: '#F2EEFF', text: '#005D99', dot: '#996DFF' },
  Rascunho:    { bg: '#F3F4F6', text: '#4B5563', dot: '#9CA3AF' },
};

// Status (enum do backend) → rótulo PT exibido.
export const mapStatus = (status?: string): string => {
  const mapping: Record<string, string> = {
    RASCUNHO: 'Rascunho', EMITINDO: 'Emitindo', EMITIDA: 'Emitida', AUTORIZADA: 'Autorizada',
    PENDENTE: 'Pendente', NEGADA: 'Negada', REJEITADA: 'Rejeitada', CANCELADA: 'Cancelada', INUTILIZADA: 'Inutilizada',
  };
  return mapping[status ?? ''] || status || 'Rascunho';
};

export const statusColor = (status?: string): StatusColor =>
  STATUS_COLORS[mapStatus(status)] ?? STATUS_COLORS.Rascunho;
